import React from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../../../providers/AuthProvider';

// Client logos for the brand strip (hosted on the Wripple marketing site CDN)
const BRAND_LOGOS = [
    '66e9c6b743a5763fc689be77_Coke%20logo.png',
    '698ce3c3a8bc44d3a0765254_Delta_c_r.png',
    '68152109bfb8965159417f30_Untitled%20%282%20x%201%20in%29%20%2812%29.png',
    '69dfb85332fe0be9e89b15a9_Tractor%20Supply%20Company.png',
    '68152046bec725cb6d78892a_Untitled%20%282%20x%201%20in%29%20%288%29.png',
    '66e9c67a0366663316bdcef2_AT%26T.png',
    '68151e84e495072030740e57_9.png',
    '68151e3941d660ffb039f305_13.png',
    '6815215bebacef5b61b9a1ad_Untitled%20%282%20x%201%20in%29%20%2813%29.png',
].map(file => `https://cdn.prod.website-files.com/6341b65bc245b8265ec4503d/${file}`);

/** Reusable branded footer: client logos, support email and Log out. */
export const BrandFooter = () => {
    const { logout } = useAuth();

    return (
        <footer className="border-t border-gray-200 bg-gray-100 px-4 py-5 md:py-6">
            <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 md:flex-row md:gap-8">
                <p className="m-0 whitespace-nowrap text-sm md:text-base font-semibold text-gray-900">
                    Work with <span className="text-secondary">great brands</span>
                </p>
                <div className="flex grow flex-wrap items-center justify-center gap-x-4 lg:gap-x-6 gap-y-3">
                    {BRAND_LOGOS.map(src => (
                        <img key={src} src={src} alt="" loading="lazy" className="h-5 md:h-6 w-auto object-contain grayscale brightness-75 opacity-80" />
                    ))}
                    <span className="rounded-full bg-white px-3 py-1 text-xs font-bold text-secondary">+ 100s more</span>
                </div>
            </div>
            <p className="m-0 mt-4 text-center text-xs md:text-sm text-gray-500">
                Questions?{' '}
                <a href="mailto:TalentTeam@wripple.com" className="text-gray-600 underline">TalentTeam@wripple.com</a>
                {' · '}
                <button type="button" onClick={() => logout()} className="bg-transparent border-0 p-0 text-gray-600 underline">
                    Log out
                </button>
            </p>
        </footer>
    );
};

/**
 * Branded canvas used for the talent "where you are" screens shown after
 * login: logo + name, one centered card, and the brand footer.
 */
const TalentStatusLayout = ({ onClose, children }) => {
    const { auth } = useAuth();

    return (
        <div className="flex min-h-screen flex-col bg-gray-100 bg-[radial-gradient(ellipse_at_center,_rgba(145,62,240,0.08),_transparent_60%)]">
            <header className="flex items-center justify-between px-4 py-4 md:px-10 md:py-5">
                <img src={TB.logoBrandImagePath()} alt={laravel.platform_name} className="h-7 md:h-9 w-auto" />
                <span className="text-sm md:text-lg font-semibold text-secondary">{auth?.fullName?.()}</span>
            </header>

            <main className="flex grow items-start justify-center px-3 pb-10 pt-2 md:px-6 md:pt-6">
                <div className="relative w-full max-w-[680px] rounded-2xl bg-white px-5 py-6 text-center shadow-[0_20px_60px_-20px_rgba(124,58,237,0.3)] md:px-9 md:py-8">
                    {onClose && (
                        <button
                            type="button"
                            aria-label="Close"
                            onClick={onClose}
                            className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full border-0 bg-gray-100 text-gray-500 hover:text-gray-900"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    )}
                    {children}
                </div>
            </main>

            <BrandFooter />
        </div>
    );
};

export default TalentStatusLayout;
